<!-- ORGANISM: AccountMenu.vue -->
<!-- App-bar account menu — activator button that opens the account card overlay. -->

<script setup lang="ts">
//
// Imports
//
import AppBarActionButton from "../molecules/AppBarActionButton.vue";
import AccountMenuCard from "./AccountMenuCard.vue";

//
// Composables
//

// Auth
const { userName, userEmail, userInitials, logout } = useAuth();

// Localization
const { t } = useI18n();

//
// State
//
const accountMenuOpen = ref(false);
</script>

<template>
  <v-menu v-model="accountMenuOpen" location="bottom" :close-on-content-click="false">
    <!-- Activator -->
    <template #activator="{ props }">
      <AppBarActionButton
        v-bind="props"
        icon="mdi-account-outline"
        :tooltip-text="t('components.common.app-bar.app_bar_actions.account_menu.tooltip')"
      />
    </template>

    <!-- Menu Content -->
    <AccountMenuCard :user-name="userName" :user-email="userEmail" :user-initials="userInitials" :logout="logout" />
  </v-menu>
</template>
